module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  
    var util = require('util/Util.js').default; 
    var constants = require('Constants.js').default;

    ; __append("\r\n\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn( dashboardTitle ))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function (crumb) {
            crumbCount++;
            if (crumbCount === count) {
            
    ; __append("\r\n            <li><span class=\"active\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</span></li>\r\n            ")
    ;  } else { 
    ; __append("\r\n            <li><a href=\"")
    ; __append(escapeFn( crumb.route ))
    ; __append("\" id=\"")
    ; __append(escapeFn( crumb.id ))
    ; __append("\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</a></li>\r\n            ")
    ; 
            }
        });
        
    ; __append("\r\n    </ol>\r\n</div>\r\n<div class=\"row\">\r\n   <div class=\"col-md-12\">\r\n      <h2>Filters</h2>\r\n   </div>\r\n</div>\r\n<div class=\"row\">\r\n   <div class=\"col-md-4\">\r\n        <div class=\"row nopadding-l\">\r\n                <input type=\"text\" placeholder=\"First Name\" name=\"firstName\" class=\"form-control\" value=\"")
    ; __append(escapeFn( this.model.get('search-firstName') ))
    ; __append("\">\r\n        </div>\r\n    </div>\r\n     <div class=\"col-md-4 nopadding-l\">\r\n        <div class=\"row \">\r\n            <input type=\"text\" placeholder=\"Last Name\" name=\"lastName\" class=\"form-control\" value=\"")
    ; __append(escapeFn( this.model.get('search-lastName') ))
    ; __append("\">\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-4\">\r\n        <div class=\"row \">\r\n            <input type=\"text\" placeholder=\"Email\" name=\"email\" class=\"form-control\" value=\"")
    ; __append(escapeFn( this.model.get('search-email') ))
    ; __append("\">\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-4\">\r\n        <div class=\"row nopadding-l\">\r\n            <select name=\"role\" class=\"main-panel-combo\">\r\n                <option value=\"-1\">Any Role</option>\r\n                <option value=\"2\">Full User</option>\r\n                <option value=\"1\">Basic User</option>\r\n                <option value=\"3\">Limited User</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-4 nopadding-l\">\r\n        <div class=\"row \">\r\n            <input type=\"text\" placeholder=\"Domain Username\" name=\"domainUsername\" class=\"form-control\" value=\"")
    ; __append(escapeFn( this.model.get('search-domainUsername') ))
    ; __append("\">\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-4\">\r\n        <div class=\"row \">\r\n            <input type=\"text\" placeholder=\"Custom ID\" name=\"customId\" class=\"form-control\" value=\"")
    ; __append(escapeFn( this.model.get('search-customId') ))
    ; __append("\">\r\n        </div>\r\n   </div>\r\n</div>\r\n<div id=\"users-section\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            ")
    ;  if(totalRecords === '1') { 
    ; __append("\r\n            <h2>1 User</h2>\r\n            ")
    ;  }else{ 
    ; __append("\r\n            <h2>")
    ; __append(escapeFn( totalRecords + ' Users' ))
    ; __append("</h2>\r\n            ")
    ;  } 
    ; __append("\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <table id=\"propMainTable\"></table>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"footer-details\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2\">\r\n            <button id='view-user' class=\"btn btn-default\" disabled>Details</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <h2>Settings Help</h2>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_QUICK_START ))
    ; __append("\" target=\"_blank\">Getting Started</a></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_PF ))
    ; __append("\" target=\"_blank\">Administering and Integrating PerfectApps</a></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_USERS ))
    ; __append("\" target=\"_blank\">Administering Users, User Groups and Positions</a></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}